import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { applyTheme, applyDarkMode, getStoredTheme, getStoredDarkMode } from "./lib/theme";

// Apply persisted theme + dark mode before first render
applyTheme(getStoredTheme());
applyDarkMode(getStoredDarkMode());

createRoot(document.getElementById("root")!).render(<App />);
